export const buildTargets = {
   operator: 'OPERATOR',
   user: 'USER'
}

export enum UserRolesEnum {
   BDE_USER = 'BDE_USER',
   PE_USER = 'PERSONAL_EDITION_USER'
}
